module.exports = __webpack_public_path__ + "b465393e275f06cf16f1ee25e1f0356c.svg";